import { Outlet, useParams } from "react-router";
import TournamentsPage from "./components/TournamentsPage";

export default function Tournaments() {
  const { competitionId } = useParams();
  return <>{competitionId ? <Outlet /> : <TournamentsPage />}</>;
}
